import { ENUM_KEY, getEnums } from 'api/enum/enumApi';

const state = {
  billingEnum: {
    billingInvoiceEmailSentProgress: [],
    hyperTapEntityList: [],
    billingDatasourceList: [],
    financialStatusList: [],
    currencyList: [],
    reconciliationProgressList: [],

    affPaymentMergeStatusList: [],
    affBillingAppStatusList: [],
    affHedgeAppAuditStatusList: [],
    affPaymentAppFinancePaymentStatusList: [],
    affPaymentAppOperationPaymentStatusList: [],
    affPaymentAppAuditStatusList: [],
    affPaymentTypeList: [],
    advInvoiceAppAuditStatusList: [],
    affHedgeAppPaymentStatusList: [],
    affPrePaidPaymentAppPaymentStatusList: [],
    affFullPaymentStatusList: [],

    advHedgeAppReceiptStatusList: [],
    advFullReceiptStatusList: [],
    advHedgeAppAuditStatusList: [],
    advReceiptClaimStatusList: [],
    advReceiptClaimCurrencyList: [],
    advReceiptClaimReceiptTypeList: [],
    advReceiptClaimReceiptStatusList: [],
  },
  billingEnumLoading: false,
};

const mutations = {
  SET_ENUMS: (state, enums) => {
    state.enums = { ...state.enums, ...enums };
  },
  SET_BILLING_ENUMS: (state, enums) => {
    state.billingEnum = enums;
  },
  SET_BILLING_LOADING: (state, isLoading) => {
    state.billingEnumLoading = isLoading;
  },
};

const actions = {
  async fetchEnum({ commit }, key) {
    commit('SET_BILLING_LOADING', true);
    const response = await getEnums(key);
    if (response && response.result) {
      commit('SET_BILLING_ENUMS', response.result);
    }
    commit('SET_BILLING_LOADING', false);
  },
  getBillingEnum({ dispatch, state }) {
    const key = ENUM_KEY.BILLING;
    if (state['billingEnum'].currencyList.length > 0 || state['billingEnumLoading']) {
      return;
    }
    dispatch('fetchEnum', key);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
